import { useEffect } from 'react';
import { useNoticeBannersStackContext } from '@sweetgreen/garnish';

export const usePermanentNoticeBanner = (
  visibility: boolean,
  text: string,
  id: string,
) => {
  const { push: addNoticeBanner, remove: removeNoticeBanner } =
    useNoticeBannersStackContext();

  useEffect(() => {
    if (!visibility) return;

    addNoticeBanner(
      {
        id,
        text,
        palette: 'success',
        autoHideTimeout: 'never',
        onClose: removeNoticeBanner,
      },
      true,
    );

    return () => {
      removeNoticeBanner(id);
    };
  }, [id, visibility, text, addNoticeBanner, removeNoticeBanner]);

  return { dismiss: removeNoticeBanner };
};
